"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _InputLabel = _interopRequireDefault(require("./InputLabel"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TextInput = require("./TextInput");
var _excluded = ["required", "label", "labelStyle", "error", "style", "labelTooltip"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Textarea = _styledComponents["default"].textarea.withConfig({
  displayName: "TextareaInput__Textarea"
})(["", ";"], (0, _styledComponents.css)(["", ";"], _TextInput.inputStyles));
var propTypes = exports.propTypes = {
  label: _propTypes["default"].string,
  labelStyle: _propTypes["default"].oneOf(_constants.TextLabelStyles),
  inputStyle: _propTypes["default"].oneOf(_constants.TextInputTypes),
  onChange: _propTypes["default"].func,
  error: _propTypes["default"].string
};
var defaultProps = exports.defaultProps = {
  inputStyle: "achievement",
  labelStyle: "dark",
  error: "",
  value: ""
};
var TextareaInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(TextareaInput, _Component);
  var _super = _createSuper(TextareaInput);
  function TextareaInput() {
    (0, _classCallCheck2["default"])(this, TextareaInput);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(TextareaInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        required = _this$props.required,
        label = _this$props.label,
        labelStyle = _this$props.labelStyle,
        error = _this$props.error,
        style = _this$props.style,
        labelTooltip = _this$props.labelTooltip,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
        required: required,
        label: label,
        labelStyle: labelStyle || rest.inputStyle,
        labelTooltip: labelTooltip
      }, /*#__PURE__*/_react["default"].createElement(Textarea, (0, _extends2["default"])({
        required: required,
        type: "textarea"
      }, rest)));
    }
  }]);
  return TextareaInput;
}(_react.Component);
TextareaInput.propTypes = propTypes;
TextareaInput.defaultProps = defaultProps;
var _default = exports["default"] = TextareaInput;